import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-10be846c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  key: 0,
  class: "text-h5 font-weight-black"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "N/A", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "text-left font-weight-black cursor-pointer checkbox-cell" }
const _hoisted_9 = { class: "text-left font-weight-black" }
const _hoisted_10 = { class: "text-left font-weight-black" }
const _hoisted_11 = { class: "text-left font-weight-black" }
const _hoisted_12 = { class: "text-left font-weight-black" }
const _hoisted_13 = { class: "text-left font-weight-black" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-left font-weight-black" }
const _hoisted_16 = { class: "text-left font-weight-black" }
const _hoisted_17 = { class: "text-left font-weight-black" }
const _hoisted_18 = { class: "text-left font-weight-black" }
const _hoisted_19 = { class: "text-left font-weight-black" }
const _hoisted_20 = { class: "text-left font-weight-black" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "no-hover" }
const _hoisted_24 = {
  colspan: "6",
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, { rounded: "lg" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center py-6" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.form)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.form.name), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('i18n.viewFormAssociatedDevicesTitle')), 1)
            ]),
            _createVNode(_component_v_btn, {
              icon: "mdi-close",
              variant: "text",
              onClick: _ctx.closeModal,
              size: "x-large"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, { class: "d-flex justify-space-between align-center" }, {
          default: _withCtx(() => [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                  key: 0,
                  type: "table"
                }))
              : (_openBlock(), _createBlock(_component_v_table, {
                  key: 1,
                  class: "table",
                  "fixed-header": "",
                  hover: _ctx.detailedAssociatedDevicesList.length !== 0,
                  height: "300px",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_8, [
                          _createVNode(_component_v_icon, {
                            class: "cursor-pointer pr-6",
                            icon: _ctx.filterActive ? 'mdi-filter-remove' : 'mdi-filter-menu',
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterActive = !_ctx.filterActive))
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('i18n.name')), 1)
                        ]),
                        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('i18n.location')), 1),
                        _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('i18n.type')), 1),
                        _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('i18n.ipAddress')), 1),
                        _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('i18n.shortURL')), 1),
                        _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('i18n.uniqueIdentifier')), 1)
                      ]),
                      (_ctx.filterActive)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                            _createElementVNode("th", _hoisted_15, [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.filters.name,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.name) = $event)),
                                density: "compact",
                                variant: "outlined",
                                "hide-details": true,
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("th", _hoisted_16, [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.filters.location,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.location) = $event)),
                                density: "compact",
                                variant: "outlined",
                                "hide-details": true,
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("th", _hoisted_17, [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.filters.type,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.type) = $event)),
                                density: "compact",
                                variant: "outlined",
                                "hide-details": true,
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("th", _hoisted_18, [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.filters.ip_address,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.ip_address) = $event)),
                                density: "compact",
                                variant: "outlined",
                                "hide-details": true,
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("th", _hoisted_19, [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.filters.short_url,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.short_url) = $event)),
                                density: "compact",
                                variant: "outlined",
                                "hide-details": true,
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("th", _hoisted_20, [
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.filters.uuid,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.uuid) = $event)),
                                density: "compact",
                                variant: "outlined",
                                "hide-details": true,
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.detailedAssociatedDevicesList.length !== 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDevices(), (device, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: index,
                              class: "text-left"
                            }, [
                              _createElementVNode("td", null, _toDisplayString(device.name), 1),
                              _createElementVNode("td", null, _toDisplayString(device.location), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.deviceTypeName(device.type_id)), 1),
                              _createElementVNode("td", null, _toDisplayString(device.ip_address), 1),
                              _createElementVNode("td", null, _toDisplayString(device.short_url), 1),
                              _createElementVNode("td", null, _toDisplayString(device.uuid), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                          _createElementVNode("tr", _hoisted_23, [
                            _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t('i18n.noDataAvailable')), 1)
                          ])
                        ]))
                  ]),
                  _: 1
                }, 8, ["hover"]))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}